// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.27624 8.00005L11.1382 12.862L10.1954 13.8048L4.39062 8.00005L10.1954 2.19531L11.1382 3.13812L6.27624 8.00005Z\" fill=\"#357456\"/> </svg> ";
// Exports
module.exports = code;